// extracted by mini-css-extract-plugin
export default {"taskListItem":"taskListItem___V2eNA","offlineModal":"offlineModal___aYGr5","paper":"paper___xjddF","content":"content___XjLFl","list":"list___vwerG"};